import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClarityConfigService {
  getTrackingId(): string {
    // Return the appropriate tracking ID based on your logic
    // For example, use different tracking IDs for different environments
    const currentDomain = window.location.hostname;
    console.log('currentDomain', currentDomain);
    if (environment.production) {
      if (currentDomain.includes('portaluat.arconcontainer.com'))
        return 'ig3haqoij9';
      else if (currentDomain.includes('portal.arconcontainer.com'))
        return 'ig3hsuyubz';
    }
    return '';
  }
}
